<template>
  <div class="productContainer">
    <div class="header">{{header_title}}</div>
    <div class="cards">
      <div v-for="(c,idx) in cates" :key="idx" class="card" @click="selectProduct(c)">
        <img-v3 :src="c.icon_url" />
        <div class="desc">
          <p class="title">{{c.title}}</p>
          <p class="tip">{{c.sub_title}}</p>
        </div>
        <span :class="{unchecked:1,checked:_product==c.product_type}"></span>
      </div>
    </div>
    <p class="btn-wraper">
      <span :class="[{'btn-productinfo-br': location_country === 'BR'}, 'btn-productinfo']" @click="goNext">{{$t('typeInfo.next_btn_desc')}}</span>
    </p>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { SUPPORT_COUNTRY, ends } from "../tools/constant";
import { post } from "../tools/request";
import { showDialog, showAlertDialog, showLoadingToast } from "../tools/Tip";
import { computeStayTime, computeJumpTime } from '../tools/utils'

export default {
  name: "productInfo",
  data() {
    return {
      timeId: null,
      pid: "2",
      configData: {}
    };
  },
  beforeDestroy() {
    clearTimeout(this.timeId);
    try {
      computeStayTime(this)
    } catch (error) {}
  },
  mounted() {
    //解决非正常流程进入--页面刷新，多次请求的bug，旧的i8n作用域已不存在，js有抛错，中断执行，，所以不会触发fn，很hack的做法
    this.timeId = setTimeout(this.getPageConfig, 0);
    try {
      Omega.trackEvent("gd_carType_view_sw", "", {
        appsflyer_uid: new URLSearchParams(location.search).get("appsflyer_uid")
      });
    } catch (e) {}
    try {
      computeJumpTime(this)
    } catch (error) {}
  },
  computed: {
    ...mapState([
      "_product",
      "_ticket",
      "_cell",
      "_uuid",
      "_role_page_skip",
      "_br_new_text",
      "_br_type_product_text",
      "_mx_type_product_text",
      "_page_stay_time",
      "_page_jump_time",
      "_route_path"
    ]),
    location_country() {
      return new URLSearchParams(location.search).get("location_country");
    },
    // cates() {
    //   let o = {
    //     BR: [
    //       {
    //         icon: require("../images/pop_99.png"),
    //         title: this.$t("product-pop-title"),
    //         tip: this.$t("product-pop-tip"),
    //         category: "pop",
    //         pid: "2"
    //       },
    //       {
    //         icon: require("../images/taxi_99.png"),
    //         title: this.$t("product-taxi-title"),
    //         tip: this.$t("product-taxi-tip"),
    //         category: "taxi",
    //         pid: "1"
    //       },
    //       {
    //         icon: require("../images/top_99.png"),
    //         title: this.$t("product-top-title"),
    //         tip: this.$t("product-top-tip"),
    //         category: "top",
    //         pid: "3"
    //       }
    //     ],
    //     CO: [
    //       {
    //         icon: require("../images/POP@3x.png"),
    //         title: this.$t("product-pop-title"),
    //         tip: this.$t("product-pop-tip"),
    //         pid: "2"
    //       },
    //       {
    //         icon: require("../images/Taxi@3x.png"),
    //         title: this.$t("product-taxi-title"),
    //         tip: this.$t("product-taxi-tip"),
    //         pid: "1"
    //       }
    //     ]
    //   };
    //   // @20201119 墨西哥产品线选择页文案实验
    //   if (this.location_country === "MX" && this._mx_type_product_text) {
    //     o["CO"][0]["title"] = "DiDi Express";
    //     o["CO"][0]["tip"] = "Conductor de vehículo privado.";
    //     o["CO"][1]["title"] = "DiDi Taxi";
    //     o["CO"][1]["tip"] = "Conductor de un taxi.";
    //   }
    //   if (
    //     this.location_country === "MX" ||
    //     this.location_country === "CL" ||
    //     this.location_country === "PR" ||
    //     this.location_country === "AR"
    //   ) {
    //     //MX、CL、PR 和CO一致
    //     return o["CO"];
    //   }
    //   if (this.location_country === "BR" && this._br_new_text) {
    //     o["BR"][0]["title"] = "Carro particular";
    //     o["BR"][0]["tip"] = "Pop ou Comfort";
    //   }
    //   // @20201029 巴西产品线选择页文案实验
    //   if (this.location_country === "BR" && this._br_type_product_text) {
    //     o["BR"][0]["title"] = "99Pop";
    //     o["BR"][0]["tip"] = "se você tem carro ou pretende alugar, selecione essa opção";
    //   }
    //   return o[this.location_country] || [];
    // },
    cates() {
      return this.configData.product_option || []
    },
    header_title() {
      // // @20201119 墨西哥产品线选择页文案实验
      // if (this.location_country === "MX" && this._mx_type_product_text) {
      //   return '¿En qué servicio quieres registrarte?';
      // } else {
      //   return this.$t('product-header');
      // }
      // @20210219 配置化改造
      return ((this.configData.title || [])[0] || {}).prompt;
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    selectProduct(item) {
      this.setState({
        _product: item.product_type
      });
    },
    goNext() {
      //@20190904 临时兼容BR跳转逻辑--BR需要经过checkProduct,且存在新老版本
      try {
        Omega.trackEvent("gd_carType_btn_ck", "", {
          carType: this._product,
          appsflyer_uid: new URLSearchParams(location.search).get(
            "appsflyer_uid"
          ),
          ibt_crm_uid: this._uuid
        });
        gtm({
          'event': 's4ObProductline',
          'ProductSelection': this._product,
         'error': 'false'
        })
      } catch (e) {}
      // if (this.location_country === "BR") {
      //   let cMap = {
      //     "1": "taxi",
      //     "2": "pop",
      //     "3": "top"
      //   };
      //   let up = new URLSearchParams(location.search);
      //   //@20190904 兼容巴西取值ticket
      //   up.set("ticket", this._ticket || up.get("ticket"));
      //   up.set("product", this._product);
      //   if (ends.inApp) {
      //     up.set("cell", this._cell);
      //     up.set("uid", this._uuid);
      //   }
      //   up.set("category", cMap[this._product]);
      //   location.href = `${location.protocol}//${location.host}${location.pathname}?${up}`;
      //   return;
      // }
      //@20190729 跳转前重置所有选项
      // @20220401 给fleet(车头)在fleet app注册做特殊处理
      if (!ends.isFleetApp) {
        this.setState({
          _identity: "3",
          _area: {
            text: "",
            value: ""
          }
        });
      }
      // let nextRoute = `typeInfo${SUPPORT_COUNTRY[this.location_country] || "Mx" }`;
      let nextRoute = 'typeInfo';
      if (this._role_page_skip[this._product]) {
        nextRoute = `baseInfo${SUPPORT_COUNTRY[this.location_country] || "Mx" }`;
      }
      this.$router.push({
        name: nextRoute
      });
    },
    defaultProduct () {
      let default_product_option = (this.configData.product_option || []).filter(item => !!item.default_select);
      // 如果配置了默认角色就选中
      if (default_product_option && default_product_option[0]) {
        this.setState({
          _product: default_product_option[0].product_type,
        });
      }

    },
    getPageConfig() {
      showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(window.location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      up.set("page_name", "product_option_page");
      post(process.env.PREORDER_INFO, up)
        .then(data => {
          this.configData = data || {};
          this.defaultProduct();
        })
        .catch(err => {
          showAlertDialog(this);
        })
        .finally(() => {
          this.toast.hide();
        });
    },
  },
};
</script>
<style lang="less" scoped>
.productContainer {
  padding-bottom: 3rem;
}
.header {
  padding: 0.55rem 0.34rem 0.34rem;
  font-size: 0.46rem;
  font-weight: bold;
  color: #333333;
}
.cards {
  .card {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: 2.12rem;
    margin: 0 0.23rem 0.23rem;
    background: #ffffff;
    border-radius: 0.08rem;
    img {
      width: 2.12rem;
      height: 2.12rem;
    }
    .title {
      margin-bottom: 0.2rem;
      font-size: 0.54rem;
      font-weight: bold;
      color: #333333;
    }
    .tip {
      padding-right: 0.6rem;
      font-size: 0.29rem;
      color: #999999;
    }
    .unchecked {
      position: absolute;
      top: 50%;
      right: 0.25rem;
      width: 0.32rem;
      height: 0.32rem;
      background: url("../images/selected-no@3x.png") no-repeat;
      background-size: 100%;
      transform: translateY(-50%);
    }
    .checked {
      background: url("../images/selected@3x.png") no-repeat;
      background-size: 100%;
    }
  }
}
.btn-wraper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0.33rem;
  background: #fff;
  box-shadow: 0 0 8px rgba(136, 136, 136, 0.5);
  .btn-productinfo {
    display: block;
    height: 1.125rem;
    width: 100%;
    font-size: 0.375rem;
    line-height: 1.125rem;
    color: #fff;
    text-align: center;
    background: #ff7226;
    border-radius: 4px;
    &.btn-productinfo-br {
      background: #FFDC14;
      color: #333333;
    }
  }
}
</style>

